import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FuseSharedModule } from '@fuse/shared.module';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CustomFormsModule } from '../custom-forms/custom-forms.module';
import { MaterialBaseButtsDialogModule } from '../material-base-butts-dialog/material-base-butts-dialog.module';

import { AngleModeSelectComponent } from './angle-mode-select/angle-mode-select.component';
import { AngleSettingsComponent } from './angle-settings.component';
import { ButtSelectComponent } from './butt-select/butt-select.component';
import { ChamferInputComponent } from './chamfer-input/chamfer-input.component';
import { CutInputComponent } from './cut-input/cut-input.component';
import { InsideCutInputComponent } from './inside-cut-input/inside-cut-input.component';
import { InsideCutWithAngleInputComponent } from './inside-cut-with-angle-input/inside-cut-with-angle-input.component';
import { MasonsMitreFInputComponent } from './masons-mitre-input/masons-mitre-input.component';
import { RoundingInputComponent } from './rounding-input/rounding-input.component';

@NgModule({
  imports: [
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCheckboxModule,

    FuseSharedModule,
    CustomFormsModule,
    DirectivesModule,
    PipesModule,
    MaterialBaseButtsDialogModule,
  ],
  declarations: [
    AngleSettingsComponent,
    AngleModeSelectComponent,
    CutInputComponent,
    RoundingInputComponent,
    ChamferInputComponent,
    ButtSelectComponent,
    InsideCutInputComponent,
    InsideCutWithAngleInputComponent,
    MasonsMitreFInputComponent,
  ],
  exports: [AngleSettingsComponent],
})
export class AngleSettingsModule {}
